module.exports = __webpack_public_path__ + "classroom_en@2x.a6c1c208.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Classroom/images/classroom_en@2x.png
// module id = /lYJ
// module chunks = 0